import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot} from "@angular/router";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs/Observable";
import {HttpCommonService} from "../services/http-common.service";

@Injectable()
export class CheckJGUserGuard implements CanActivate{

  constructor(private http:HttpCommonService){

  }
  canActivate(route: ActivatedRouteSnapshot,
              state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {




     return new Observable((observer) => {
       this.http.get("/user/center/xhsRest/checkJGUser").subscribe(
         result =>{
           console.log(result);
           if(result.stateCode =='1'){
             observer.next(true);
             observer.complete();
           }else{
             observer.next(false);
             observer.complete();
           }
         }
       );
     });
  }

}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/guard/checkJGUser.ts